import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDrag, useDrop, DragElementWrapper } from "react-dnd";
import classnames from "classnames";

import styles from "./high-frequency-word.module.css";
import * as highFrequencyWordActions from "../../redux/actions/highFrequencyWord";
import { srcPath } from "../../util/Path";
import { dndItemTypes } from "../../react-dnd/DndConfig";
import { State } from "../../redux/store";

interface Props {
  word: string;
  index?: number;
  style?: any;
  canDrag?: boolean;
}

interface Item {
  type: string;
  word: string;
  index: number;
}

interface Filled {
  dragRef: DragElementWrapper<any>;
  canDrag: boolean;
  word: string;
  style?: any;
}

export const WordCardFilled = (props: Filled) => {
  const { dragRef, canDrag, word, style } = props;

  return (
    <div
      ref={canDrag ? dragRef : null}
      className={styles.wordCard}
      style={{
        ...style,
      }}
    >
      <img
        className={styles.wordCardBg}
        src={srcPath("high-frequency-word/word_card.png")}
        alt=""
      />
      <div className={classnames("noselect", styles.wordCardText)}>{word}</div>
    </div>
  );
};

const WordCard = (props: Props) => {
  const dispatch = useDispatch();
  const { word, index, style, canDrag = true } = props;
  const { truckActive } = useSelector(
    (state: State) => state.highFrequencyWord
  );

  const dragCard = (item: Item) => {
    const { word, index } = item;
    dispatch(highFrequencyWordActions.dragCard(word, index));
    dispatch(highFrequencyWordActions.checkAnswer());
  };

  const [{ isDragging }, drag] = useDrag({
    item: {
      type: dndItemTypes.HIGH_FREQUENCY_WORD_CARD,
      word,
      index,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: dndItemTypes.HIGH_FREQUENCY_WORD_CARD,
    drop: dragCard,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  // drag
  if (word && !isDragging) {
    return (
      <WordCardFilled
        dragRef={truckActive ? drag : null}
        canDrag={canDrag}
        word={word}
        style={style}
      />
    );
  }

  // drop
  if (index === undefined) {
    return (
      <div
        ref={truckActive ? drop : null}
        className={styles.wordCardPlaceholder}
        style={{
          opacity: isOver ? 0.2 : 0.5,
          cursor: isOver ? "move" : "default",
        }}
      ></div>
    );
  }

  // empty
  return <div className={styles.wordCardEmpty}></div>;
};

export default WordCard;
